<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 1991 by Karla Hocker<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition December 2014<br/>
  ISBN: 978-1-62681-576-6</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">Also by Karla Hocker</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/MoreFrom" title="Link target outside of Sample">An Honorable Affair<br/>
  Lady Maryann's Dilemma<br/>
  A Daring Alliance<br/>
  The Devilish Marquis<br/>
  A Christmas Charade<br/>
  Love Tangle<br/>
  A Deceitful Heart<br/>
  An Improper Companion</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<p class="sectiontop" style="text-align: center;"><i>To Carin Cohen Ritter</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01B_copy.vue?696cc308